import { ColorRepository } from "../Repository/ColorRepository";


export interface DeleteColorUseCase {
    invoke: (id: string) => Promise<boolean>;
  }
  
  export class RemoveColor implements DeleteColorUseCase {
    private colorRepo: ColorRepository;
    constructor(_ColorRepo: ColorRepository) {
      this.colorRepo = _ColorRepo;
    }
  
    async invoke(id: string){
       
        if(!id){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const deleted  = await this.colorRepo.removeColor(id);
        return deleted;
    }
  }